<section class="rv-pdf" *ngIf="visita as v">
  <header class="rv-pdf__header" id="pdf-header">
    <div class="rv-pdf__header-top">
      <div class="rv-pdf__header-left">
        <img class="rv-pdf__logo" [src]="logoSrc" alt="Logo INDAP" />
      </div>
      <div class="rv-pdf__header-right">
        <div class="rv-pdf__header-right-line">Plataforma Programa SAT</div>
        <div class="rv-pdf__header-right-line">Gestión de Asesorías Técnicas</div>
      </div>
    </div>
  </header>

  <main class="rv-pdf__content">
    <div id="pdf-section-header">
      <h1 class="rv-pdf__header-title">Detalle de Visita</h1>

      <div class="rv-pdf__datos" *ngIf="v.productor as p">
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Productor:</span>
          <span class="rv-pdf__dato-value">{{ p.nombre }} {{ p.primer_apellido }} {{ p.segundo_apellido }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">RUT:</span>
          <span class="rv-pdf__dato-value">{{ p.rut || '-' }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Unidad Operativa:</span>
          <span class="rv-pdf__dato-value">{{ p.jerarquia.descripcion || '-' }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Rubro Principal:</span>
          <span class="rv-pdf__dato-value">{{ v.tipo || '-' }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Elaborado por:</span>
          <span class="rv-pdf__dato-value">{{ meta?.extensionista || v.usuario_registro || v.usuario || '-' }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Aprobado por:</span>
          <span class="rv-pdf__dato-value">{{ '-' }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Fecha de Aprobación:</span>
          <span class="rv-pdf__dato-value">{{ formatearFechaLarga(meta?.fecha_emision) }}</span>
        </div>
        <div class="rv-pdf__dato">
          <span class="rv-pdf__dato-label">Estado:</span>
          <span class="rv-pdf__dato-value">{{ v.estado || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- SECCIÓN 1: INFORMACIÓN DE LA VISITA -->
    <section class="rv-pdf__section" id="pdf-section-1">
      <div class="rv-pdf__section-title">1. Información de la Visita</div>
      <table class="rv-pdf__table">
        <tbody>
          <tr>
            <td class="rv-pdf__td-label">Lugar</td>
            <td>{{ v.lugar || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Fecha Programada</td>
            <td>{{ formatearFecha(v.fecha) }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Hora Programada</td>
            <td>{{ formatearHora(v.fecha) }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Tipo de Visita</td>
            <td>{{ v.tipo || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Bolsa de Visita</td>
            <td>{{ v.bolsa_visita === true ? 'SÍ' : (v.bolsa_visita === false ? 'NO' : '-') }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Descripción</td>
            <td class="rv-pdf__cell-text">{{ v.descripcion || '-' }}</td>
          </tr>
          <tr *ngIf="(v.estado || '').toLowerCase() === 'planificada' && v.fecha_inicio_planificada">
            <td class="rv-pdf__td-label">Fecha inicio planificada</td>
            <td>{{ v.fecha_inicio_planificada }}</td>
          </tr>
          <tr *ngIf="(v.estado || '').toLowerCase() === 'planificada' && v.fecha_termino_planificada">
            <td class="rv-pdf__td-label">Fecha término planificada</td>
            <td>{{ v.fecha_termino_planificada }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Es emergencia</td>
            <td>{{ v.es_contingencia ? 'SÍ' : 'NO' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Descripción Emergencia</td>
            <td>{{ v.descripcion_emergencia || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- SECCIÓN 2: REGISTRO DE LA VISITA -->
    <section class="rv-pdf__section" id="pdf-section-2">
      <div class="rv-pdf__section-title">2. Registro de la Visita</div>
      <table class="rv-pdf__table">
        <tbody>
          <tr>
            <td class="rv-pdf__td-label">Fecha de Visita</td>
            <td>{{ formatearFecha(v.fecha_visita || v.fecha) }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Hora Inicio</td>
            <td>{{ v.hora_inicio || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Hora Término</td>
            <td>{{ v.hora_termino || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Tipo de Reporte</td>
            <td>{{ v.tipo_reporte || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Modalidad de contacto</td>
            <td>{{ textoModalidadContactoVisita() }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Temas</td>
            <td>{{ textoObjetivosVisita() }}</td>
          </tr>
          <tr *ngIf="v.objetivo_otro">
            <td class="rv-pdf__td-label">Describa otro (Tema)</td>
            <td class="rv-pdf__cell-text">{{ v.objetivo_otro }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Folio</td>
            <td>{{ v.folio || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Recomendaciones</td>
            <td class="rv-pdf__cell-text">{{ v.recomendaciones || '-' }}</td>
          </tr>
          <tr>
            <td class="rv-pdf__td-label">Compromisos</td>
            <td class="rv-pdf__cell-text">
              @let lineas = lineasCompromisos(v.compromisos);
              @if (lineas.length > 0) {
                <ul class="rv-pdf__lista">
                  @for (linea of lineas; track linea) {
                    <li>{{ linea }}</li>
                  }
                </ul>
              } @else {
                -
              }
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <div class="rv-pdf__signature" id="pdf-signature">
      <div class="rv-pdf__signature-line"></div>
      <div class="rv-pdf__signature-text">Firma</div>
    </div>

    <footer class="rv-pdf__footer" id="pdf-footer">
      Descargado el {{ ahora }}
    </footer>
  </main>
</section>
